import React from 'react';

import {
  FEATURE_GATES,
  PermissionFilter,
  GlobalFeatureGateFilter
} from '@sopranodesign/pulse-auth';
import {
  Panel,
  PageWrapper
} from '@sopranodesign/pulse-components';

import { Confluence } from '../Components';

const ConfluencePage = () => (
  <PageWrapper beta="true" header="Confluence" subheader="Configure your Confluence">
    <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI}>
      <GlobalFeatureGateFilter for={FEATURE_GATES.GENERATIVE_AI_CONFLUENCE}>
        <PermissionFilter can="view generative ai resource">
          <Panel>
            <Confluence />
          </Panel>
        </PermissionFilter>
      </GlobalFeatureGateFilter>
    </GlobalFeatureGateFilter>
  </PageWrapper>
);

export default ConfluencePage;
